import React, {Fragment} from 'react';
import { BaseColumn } from '../../../components/shared/sharedStyles.styles';
import FilterField from './FilterField';
import DateSearchField from './DateSearchFieldBaixarCobranca';
import {
  FilterIcon,
  FilterButton,
  FilterText,
  ChargeFilterCard,
  ChargeFilterForm,
  ChargeSelectFieldGroup,
  ChargeFilterTypeSegment,
  ChargeFilterTypeSegmentButton,
  ChargeSearchFieldGroup,
  ChargeDateFieldGroup,
  ChargeFilterTypeSelect,
  ChargeFilterSubmitButton,
  ChargeFilterCardMobileFix
} from './SearchStyles'
import filter from '../../../img/svg/ico-filter.svg';

const SearchGroupBaixarCobranca = ({setFilter, endDate, startDate, filterDate, hiddenInputFilter, changeSelectFilter, resetSelectFilter, selectedOption, showSelectFilter}) => {
    const onFormSubmit = e => {
      e.preventDefault()
      filterDate()
    }

    const resetSelected = () => {

    }

    const selectedFilter = selectedOption || 'cobranca_id'
    const placeholder = selectedFilter === 'cobranca_id' ? 'Filtrar ID de Cobrança' : selectedFilter === 'solicitacao_id' ? 'Filtrar ID Solicitação' : "Filtrar ID de Cobrança"

    return (
        <BaseColumn xs="12" sm="12" md="12" lg="12" xl="12" style={{paddingBottom: '.55em'}}>
          <ChargeFilterCardMobileFix>
          <ChargeFilterCard>
            <ChargeFilterForm onSubmit={onFormSubmit}>
              {showSelectFilter &&
                <ChargeSelectFieldGroup>
                    <FilterIcon src={filter} alt="" />
                    <ChargeFilterTypeSelect onChange={changeSelectFilter} value={selectedFilter}>
                      <option value="cobranca_id">ID de Cobrança</option>
                      <option value="solicitacao_id">ID Solicitação</option>
                    </ChargeFilterTypeSelect>
                    <ChargeFilterTypeSegment>
                      <ChargeFilterTypeSegmentButton
                        type="button"
                        active={selectedFilter === 'cobranca_id'}
                        onClick={() => changeSelectFilter({ target: { value: 'cobranca_id' } })}
                      >
                        ID de Cobrança
                      </ChargeFilterTypeSegmentButton>
                      <ChargeFilterTypeSegmentButton
                        type="button"
                        active={selectedFilter === 'solicitacao_id'}
                        onClick={() => changeSelectFilter({ target: { value: 'solicitacao_id' } })}
                      >
                        ID Solicitação
                      </ChargeFilterTypeSegmentButton>
                    </ChargeFilterTypeSegment>
                </ChargeSelectFieldGroup>
              }

              {!hiddenInputFilter &&
                <ChargeSearchFieldGroup>
                    <FilterIcon src={filter} alt="" />
                    <FilterField
                        type="text"
                        placeholder={placeholder}
                        submitSearch={setFilter}
                        noIcon={true}
                    />
                </ChargeSearchFieldGroup>
              }
              
              <ChargeDateFieldGroup>
                  <FilterIcon src={filter} alt="" style={{marginRight: "2px"}} />
                  <FilterText style={{ fontWeight: 600, fontSize: '13px' }}>De</FilterText>
                  <DateSearchField
                      type="text"
                      placeholder="mm/aaaa"
                      submitSearch={startDate}
                  />
                  <FilterText style={{ fontWeight: 600, fontSize: '13px' }}>a</FilterText>
                  <DateSearchField
                      type="text"
                      placeholder="mm/aaaa"
                      submitSearch={endDate}
                  />
                  <ChargeFilterSubmitButton type="submit">
                      Filtrar
                  </ChargeFilterSubmitButton>
              </ChargeDateFieldGroup>
            </ChargeFilterForm>
          </ChargeFilterCard>
          </ChargeFilterCardMobileFix>
        </BaseColumn>
    )
}

export default SearchGroupBaixarCobranca